<template>
  <div id="CardPayment">
    <div class="header">
      <div class="van-hairline--bottom background_color_d6f1ec van-nav-bar font_weight_bold" style="z-index: 1;">
        <div class="van-nav-bar__left">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="color: #000000 !important;" @click="$router.back(-1)"></i>
        </div>
        <div class="van-ellipsis van-nav-bar__title">{{ $t("member.title") }}</div>
      </div>
    </div>
    <div class="bodyer">
      <!-- 
      <iframe id="monerisFrame" :src="htSrc" frameborder="0" width="500px" height="150px"></iframe>
        src="https://esqa.moneris.com/HPPtoken/index.php?id=ht55DIVXERCSCCJ&display_labels=1&enable_exp=1&enable_cvd=1&css_bodybackground:white;&css_textboxborder-width:1px; height: 32px; padding: 0 10px; margin-bottom: 10px; background-color: whitesmoke; font-size: 14px;color: black; border-top: 0; border-right: 0 !important; border-left: 0 !important; border-bottom: 1px solid silver !important; font-family: 'Open Sans', sans-serif; font-weight: 400;&css_textbox_panbackground:white;&css_textbox_expbackground:white;&css_textbox_cvdbackground:white;&css_label_panbackground:white;&css_label_expbackground:white;&css_label_cvdbackground:white;"
        src="https://esqa.moneris.com/HPPtoken/index.php?id=ht55DIVXERCSCCJ&amp;css_body=background:green;border:2px"        
        -->

      <iframe
        ref="monerisFrame"
        v-show="monerisFrameVisible"
        v-on:load="monerisFrameLoaded"
        :src="htSrc"
        frameborder="0"
        width="250px"
        height="200px"
      ></iframe>

      <input type="text" v-model="amount" placeholder="Amount" />
      <input type="button" v-show="monerisFrameVisible" @click="monerisSubmit" value="Submit Payment" />
      <div ref="monerisResponse">{{ monerisResponseError }}</div>
    </div>
  </div>
</template>

<script>
/** HIDDEN */
export default {
  name: "cardPayment",
  computed: {
    member() {
      return this.$store.state.member;
    },
  },
  data() {
    return {
      monerisResponseError: "",
      monerisFrameVisible: false,
      htProfileId: "",

      htDisplayLabels: "1",
      htEnableExpDate: "1",
      htEnableCVD: "1",
      htCssBody: "background:white;",
      htCssTextbox:
        "border-width:1px; height: 32px; padding: 0 10px; margin-bottom: 10px; background-color: whitesmoke; font-size: 14px;color: black; border-top: 0; border-right: 0 !important; border-left: 0 !important; border-bottom: 1px solid silver !important; font-family: 'Open Sans', sans-serif; font-weight: 400;",
      htCssTextboxPan: "width:100px;",
      htCssTextboxExp: "width:80px;",
      htCssTextboxCVD: "width:60px;",
      htCssInputLabel: ";",
      htCssLabelPan: "font-family: 'Open Sans',sans-serif; font-weight: 600; font-size: 14px; color: black; margin-bottom: 10px;",

      htUrl: "",
      htRespOrigin: "esqa.moneris.com",

      htSrc: "",
      amount: 12.5,
    };
  },
  mounted() {
    this.$parent.curTab = 4;

    this.monerisFrameSrc();
    if (window.addEventListener) {
      window.addEventListener("message", this.monerisMsgListener, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", this.monerisMsgListener);
    }
  },
  beforeDestroy() {
    if (window.removeEventListener) {
      window.removeEventListener("message", this.monerisMsgListener);
    } else if (window.detachEvent) {
      window.detachEvent("onmessage", this.monerisMsgListener);
    }
  },
  methods: {
    // ------------------------------------------------------------------------ monerisFrameSrc
    monerisFrameSrc() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      $this.$ajax2
        .post("PaymentProfileInfo", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.htProfileId = rpdata.data.data.ProfileId;
            $this.htUrl = rpdata.data.data.ProfileUrl;
            // $this.htUrl = "https://esqa.moneris.com/HPPtoken/index.php";

            // check the parameters from
            // https://developer.moneris.com/en/Documentation/NA/E-Commerce%20Solutions/Hosted%20Solutions/Hosted%20Tokenization
            var params = "?id=" + $this.htProfileId;
            params += "&display_labels=" + $this.htDisplayLabels;
            params += "&enable_exp=" + $this.htEnableExpDate;
            params += "&enable_cvd=" + $this.htEnableCVD;
            params += "&css_body=" + $this.htCssBody;
            params += "&css_textbox=" + $this.htCssTextbox;
            params += "&css_textbox_pan=" + $this.htCssTextboxPan;
            params += "&css_textbox_exp=" + $this.htCssTextboxExp;
            params += "&css_textbox_cvd=" + $this.htCssTextboxCVD;
            params += "&css_input_label=" + $this.htCssInputLabel;
            params += "&css_label_pan=" + $this.htCssLabelPan;
            params += "&css_label_exp=" + $this.htCssLabelExp;
            params += "&css_label_cvd=" + $this.htCssLabelCVD;
            $this.htSrc = $this.htUrl + params;
          } else {
            alert("unsuccessful");
          }
        })
        .catch(function(err) {
          console.log(err);
        }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ monerisMsgListener
    monerisMsgListener(e) {
      let $this = this;
      if (e.origin != null && e.origin.includes(this.htRespOrigin)) {
        var respData = eval("(" + e.data + ")");
        if ("errorMessage" in respData) {
          this.monerisResponseError = respData.errorMessage;
        } else if ("dataKey" in respData) {
          this.monerisResponseError = "Validaing Payment Information . . .";
          let obj = {
            AppVersion: this.$version,
            SessionId: this.member.SessionId,
            SessionToken: this.member.SessionToken,
            Amount: this.amount,
            DataKey: respData.dataKey,
            DataBin: "bin" in respData ? respData.bin : "",
          };
          this.$ajax2
            .post("PaymentMakePurchase", obj, $this.$ajaxHeader)
            .then(function(rpdata) {
              if (rpdata.data.meta.code == "200") {
                $this.monerisResponseError = "data key is " + rpdata.data.data.DataKey;
              } else {
                alert("unsuccessful");
              }
            })
            .catch(function(err) {
              console.log(err);
            }); // eslint-disable-line

          // this.monerisResponseError = "";
          this.monerisFrameVisible = false;
        }
      }
    },
    // ------------------------------------------------------------------------ monerisFrameLoaded
    monerisFrameLoaded() {
      this.monerisFrameVisible = true;
    },
    // ------------------------------------------------------------------------ monerisSubmit
    monerisSubmit() {
      this.$refs.monerisFrame.contentWindow.postMessage("tokenize", this.htUrl);
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
